import ExportActions from 'exports/ExportActions';
import {FolderDefaultsKey} from 'FolderDefaults';
import ProtocolActions from 'notebook/protocols/actions/ProtocolActions';
import Protocol from 'notebook/protocols/backbone/filestate/Protocol';
import BasicInformationPanelView from 'toolbar/shared/BasicInformationPanelView';

class ProtocolInformationPanelView extends BasicInformationPanelView<Protocol> {
  override folderDefaultsKey(): FolderDefaultsKey {
    return FolderDefaultsKey.NOTEBOOK;
  }

  // as with other BasicInformationPanelView children, `el` is a selector, not a JQuery
  override initialize(options: Backbone.ViewOptions<Protocol>): void {
    this.saveModel = this.saveModel.bind(this);
    this.deleteModel = this.deleteModel.bind(this);
    this.requestExport = this.requestExport.bind(this);
    super.initialize(options);
  }

  override saveModel(data: {tagSchemaId: string | null}): void {
    // eslint-disable-next-line @typescript-eslint/unbound-method -- rebound in BasicInformationPanelView.initialize()
    ProtocolActions.update(this.model.id, data, {success: this.onSaveSuccess});
  }

  override deleteModel(): void {
    // eslint-disable-next-line @typescript-eslint/unbound-method -- rebound in BasicInformationPanelView.initialize()
    ProtocolActions.delete(this.model.id, {success: this.onDeleteSuccess});
  }

  requestExport(): void {
    ExportActions.requestExportFile(this.model.id);
  }
}

export default ProtocolInformationPanelView;
